module.exports = __webpack_public_path__ + "static/img/40_pro.9effbad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/40_pro.jpg
// module id = Q9gw
// module chunks = 0